import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axiosInstance from '../../axiosConfig';
import MessageBoard from './MessageBoard';
import './PostDetail.css';
import RingLoader from "react-spinners/RingLoader";

const PostDetail = () => {
  const { id: postId } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        // Step 1: Get course_id by post_id
        const postResponse = await axiosInstance.get(`/messageboard//post/${postId}/course/`);
        const courseId = postResponse.data.course_id;

        // Step 2: Fetch course details
        const courseResponse = await axiosInstance.get(`/courses/${courseId}/`);
        setCourse(courseResponse.data);
      } catch (error) {
        console.error('Error fetching course details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseDetails();
  }, [postId]);

  return (
    <div className="course-detail">
      {loading ? (
        <div className="loading-spinner-post">
          <RingLoader />
        </div>
      ) : (
        <>
          {course && (
            <div className="course-info-container">
              <div className="course-header-container">
                <h1 className="course-name">{course.golf_course}</h1>
              </div>
              <hr className="section-divider" />
              <hr className="divider" />

              <div className="course-info">
                <p><strong>Address:</strong> {course.address || 'Address Unknown'}</p>
                <p><strong>Phone:</strong> {course.phone_number || 'Phone Unknown'}</p>
                <p><strong>Access Type:</strong> {course.access_type || 'Unknown'}</p>

                <hr className="section-divider" />
                <div className="course-links">
                  <Link to={`/course/${course.id}`} className="view-details">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          )}
          <div className="messageboard-container-post">
            <MessageBoard postId={parseInt(postId, 10)} />
          </div>
        </>
      )}
    </div>
  );
};

export default PostDetail;